module.exports = __webpack_public_path__ + "static/media/ursuline-academy.cd7d255b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/ursuline-academy.jpg
// module id = 637
// module chunks = 0